import { MessageSquare, Sparkles, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForRenewalRemindersAr: TemplateAr = {
  name: 'مكالمات ذكية للتذكير بالتجديد',
  description:
    'مكالمات هاتفية آلية بالذكاء الاصطناعي لتذكير العملاء بتجديد العقد أو الاشتراك القادم، وتقليل فقدان العملاء.',
  category: 'المكالمات بالذكاء الاصطناعي',
  workflow: [
    { icon: MessageSquare, label: 'موعد التجديد' },
    { icon: Sparkles, label: 'اتصال ذكي' },
    { icon: Star, label: 'التجديد تأكد', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ذكّر عميلك بتجديده قبل ما يفوت الموعد. الـ AI يبادر بالتواصل، ويذكّر بموعد التجديد، ويجاوب على أسئلته حول المزايا الجديدة أو الأسعار، ويعالج التجديد عبر الهاتف. ويحدد العميل المعرّض للفقدان، ويصعّده لمدير الحساب.',
    paragraph2:
      'تأكيدات التجديد وإشارات الخطر توصل للـ CRM أو نظام الفوترة أو منصة نجاح العملاء عندك. والـ AI يتتبّع محادثات التجديد ويتابعها تلقائياً. وأول ما يرصد خطر الفقدان، يشغّل مسارات الاحتفاظ بالعميل.',
  },
  benefits: [
    'الفقدان السلبي للعملاء ينزل وتلاحظ الفرق',
    'الـ AI يرصد العميل المعرّض للفقدان مبكراً',
    'التجديد يتم بدون تدخل يدوي',
    'إدارة الحسابات توفّر وقتها',
    'معدلات التجديد ترتفع',
    'فرص البيع الإضافي تطلع في نفس مكالمة التجديد',
  ],
};
